import { CurrentStationObsProvider } from '../providers/currentStationsObsProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_CURRENT_OBS_BY_LATLON = new AsyncAction('GET_CURRENT_OBS_BY_LATLON');

export function getCurrentStationObsByLatLon(...params) {

    let paramsObject = {
        location: undefined,
        locationType: undefined,
        offset: undefined,
        units: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined,
        lengthUnit: undefined,
        tempUnit: undefined,
        pressureUnit: undefined,
        speedUnit: undefined,
        stationId: undefined,
        providerId: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_CURRENT_OBS_BY_LATLON.base,
        payload: getCurrentStationObs(paramsObject)
    };
}

export async function getCurrentStationObs({ location, locationType, offset, units, baseUrl, authId, secret, stdParameters, verbose, refresh, lengthUnit, tempUnit, pressureUnit, speedUnit, stationId, providerId }) {
    const op = new CurrentStationObsProvider(baseUrl, authId, secret);
    return await op.getCurrentStationObs(location, locationType, offset, units, stdParameters, verbose, refresh, lengthUnit, tempUnit, pressureUnit, speedUnit, stationId, providerId);
}
